export const knowledgeBaseHomepageLink = 'https://help.smartsheet.com/brandfolder';
export const historyLogLink = 'https://help.smartsheet.com/13664386046487-Asset-History-Log';
export const userPermissionsLink = 'https://help.smartsheet.com/115002602273-User-Permissions';
export const userGroupsKnowledgeBaseLink = 'https://help.smartsheet.com/9199616080279-User-Groups-';
export const dependentCustomFieldsKnowledgeBaseLink = 'https://help.smartsheet.com/13735397807895-Dependent-custom-fields';
